(function () {
    function getCsrfToken() {
        return window._cc ? window._cc.getCsrfToken() : '';
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-md-toggle]');
        if (!btn) return;
        var container = btn.closest('[data-md-container]');
        if (!container) return;
        var editPane = container.querySelector('[data-md-edit]');
        var viewPane = container.querySelector('[data-md-view]');
        var icon = btn.querySelector('i');
        if (!editPane || !viewPane) return;

        var showingEdit = editPane.style.display !== 'none';
        if (showingEdit) {
            refreshPreview(container, function () {
                editPane.style.display = 'none';
                viewPane.style.display = '';
                if (icon) icon.className = 'fa-solid fa-pencil';
            });
        } else {
            viewPane.style.display = 'none';
            editPane.style.display = '';
            if (icon) icon.className = 'fa-solid fa-eye';
            var ta = editPane.querySelector('textarea');
            if (ta) ta.focus();
        }
    });

    function refreshPreview(container, callback) {
        var ta = container.querySelector('[data-md-edit] textarea');
        var viewPane = container.querySelector('[data-md-view]');
        if (!ta || !viewPane) return;
        var url = ta.getAttribute('data-md-preview-url');
        if (!url) return;
        var fd = new FormData();
        fd.append('text', ta.value);
        fetch(url, { method: 'POST', body: fd, headers: { 'X-CSRFToken': getCsrfToken() } })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
            .then(function (html) {
                if (html) {
                    viewPane.innerHTML = '<div class="prose">' + html + '</div>';
                } else {
                    viewPane.innerHTML = '<div class="text-muted fs-sm">Nothing to preview.</div>';
                }
                if (callback) callback();
            })
            .catch(function () {
                if (window.SeeMe && window.SeeMe.toast) SeeMe.toast.error('Failed to load preview');
            });
    }

    // After HTMX blur-save, refresh preview if currently showing
    window._mdRefreshPreview = function (el) {
        var container = el.closest('[data-md-container]');
        if (!container) return;
        var viewPane = container.querySelector('[data-md-view]');
        if (viewPane && viewPane.style.display !== 'none') {
            refreshPreview(container);
        }
    };
})();
